import { CheckBoxOff, CheckBoxOn } from '@assets/icons';
import { Checkbox, HighlightMatch, PermissionAccess } from '@components/index';
import { UserPermissions } from '@enums/user-permissions';

import { SelectMoreAction } from './SelectMoreAction';
import { ContentModalActionType, Label, LabelItem } from './types';

type Props = {
  item: LabelItem;
  onSelectOption: (option: any) => void;
  isSelected: boolean;
  searchInput?: string;
  handleActionClick: (data: Label, action: ContentModalActionType) => void;
  disableLabel?: boolean;
  isFilterMode?: boolean;
};

export const SelectLabelItem = (props: Props) => {
  const {
    item,
    onSelectOption,
    isSelected,
    searchInput = '',
    handleActionClick,
    disableLabel = false,
    isFilterMode = false,
  } = props;

  const { name } = item;

  const isSearchApplied = searchInput !== '';
  const isInheritedLabel = !!item.parentId;

  const handleClick = () => {
    if (!disableLabel) {
      onSelectOption(item);
    }
  };

  const renderLabelItem = (isDisabled: boolean = false) => {
    const containerClasses = `px-2 py-1 flex items-center justify-between gap-2.5 rounded ${
      isDisabled
        ? 'cursor-not-allowed'
        : 'hover:bg-modal-surface-hover cursor-pointer'
    }`;

    const innerClasses = `flex items-center gap-2.5 flex-1 ${
      isDisabled ? 'opacity-50 text-dark-3' : ''
    }`;

    const renderCheckbox = () => {
      if (isDisabled) {
        return (
          <div className="flex-shrink-0">
            {isSelected ? (
              <CheckBoxOn className="text-dark-3" />
            ) : (
              <CheckBoxOff className="text-dark-3" />
            )}
          </div>
        );
      }

      return <Checkbox checked={isSelected} />;
    };

    const renderLabelText = () => (
      <div className="flex flex-1 break-all items-center flex-grow text-left text-text-primary font-medium text-sm">
        {isSearchApplied ? (
          <HighlightMatch text={name} match={searchInput} />
        ) : (
          <>{name}</>
        )}
      </div>
    );

    return (
      <div
        className={containerClasses}
        onClick={isDisabled ? undefined : handleClick}
      >
        <div className={innerClasses}>
          {renderCheckbox()}
          {renderLabelText()}
        </div>
        <SelectMoreAction
          data={item}
          handleActionClick={handleActionClick}
          isInheritedLabel={isInheritedLabel}
        />
      </div>
    );
  };

  return (
    <PermissionAccess
      hasPermission={isFilterMode}
      permission={UserPermissions.MANAGE_BRAND_LIBRARY}
      AllowedContent={renderLabelItem(disableLabel)}
      DeniedContent={renderLabelItem(true)}
    />
  );
};
